// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"3471892a","253":"91835689","294":"5cec2885","384":"7f2fc9d0","399":"ab5eacae","542":"ed843b4d","664":"ff139bf1","849":"1382cf70","908":"fabe966e","983":"5587fc31"}[chunkId] + ".chunk.js";
};